export const languagesTranslations = {
  // Languages tab translations
  loading: {
    en: 'Loading...',
    fi: 'Ladataan...'
  },
  noLanguagesFound: {
    en: 'No languages found.',
    fi: 'Kieliä ei löydy.'
  },
  noLanguages: {
    en: 'No languages',
    fi: 'Ei kieliä'
  },
  languages: {
    en: 'Languages',
    fi: 'Kielet'
  },
  addLanguage: {
    en: 'Add Language',
    fi: 'Lisää kieli'
  },
  editLanguage: {
    en: 'Edit Language',
    fi: 'Muokkaa kieltä'
  },
  language: {
    en: 'Language',
    fi: 'Kieli'
  },
  languageName: {
    en: 'Language Name',
    fi: 'Kielen nimi'
  },
  languageNamePlaceholder: {
    en: 'e.g., English, Finnish, German',
    fi: 'esim. Englanti, Suomi, Saksa'
  },
  languageLevel: {
    en: 'Proficiency Level',
    fi: 'Taitotaso'
  },
  selectLanguage: {
    en: 'Select Language',
    fi: 'Valitse kieli'
  },
  // Language levels as flat keys - this structure is what the components are using
  'languageLevels.basics': {
    en: 'Basics',
    fi: 'Perusteet'
  },
  'languageLevels.good': {
    en: 'Good',
    fi: 'Hyvä'
  },
  'languageLevels.fluent': {
    en: 'Fluent',
    fi: 'Erinomainen'
  },
  'languageLevels.native': {
    en: 'Native language',
    fi: 'Äidinkieli'
  },
  // Language levels
  level: {
    en: 'Level',
    fi: 'Taso'
  },
  // Form actions
  save: {
    en: 'Save',
    fi: 'Tallenna'
  },
  saving: {
    en: 'Saving...',
    fi: 'Tallennetaan...'
  },
  cancel: {
    en: 'Cancel',
    fi: 'Peruuta'
  },
  edit: {
    en: 'Edit',
    fi: 'Muokkaa'
  },
  delete: {
    en: 'Delete',
    fi: 'Poista'
  },
  // Success messages
  success: {
    en: 'Success',
    fi: 'Onnistui'
  },
  languageAddedSuccess: {
    en: 'Language added successfully',
    fi: 'Kieli lisätty onnistuneesti'
  },
  languageUpdatedSuccess: {
    en: 'Language updated successfully',
    fi: 'Kieli päivitetty onnistuneesti'
  },
  languageDeletedSuccess: {
    en: 'Language deleted successfully',
    fi: 'Kieli poistettu onnistuneesti'
  },
  // Error messages
  error: {
    en: 'Error',
    fi: 'Virhe'
  },
  confirmDeleteLanguage: {
    en: 'Are you sure you want to delete this language?',
    fi: 'Haluatko varmasti poistaa tämän kielen?'
  },
  required: {
    en: 'Required',
    fi: 'Pakollinen'
  },
  languagePlaceholder: {
    en: 'Enter language',
    fi: 'Syötä kieli'
  },
  invalidLanguageError: {
    en: 'The language is not valid. Please choose from the available languages.',
    fi: 'Kieli ei ole kelvollinen. Valitse kieli saatavilla olevista kielistä.'
  }
};